// Ticket 31: Speed Dating API

const API_BASE = window.location.origin;

export async function fetchUpcomingSpeedDatingEvents() {
  const token = localStorage.getItem('token');
  const res = await fetch(`${API_BASE}/api/speeddating/events/upcoming`, {
    headers: {
      Authorization: token ? `Bearer ${token}` : '',
    },
  });
  
  if (!res.ok) {
    throw new Error('Failed to fetch speed dating events');
  }
  
  return res.json();
}

export async function joinSpeedDatingEvent(eventId) {
  const token = localStorage.getItem('token');
  const res = await fetch(`${API_BASE}/api/speeddating/events/${eventId}/join`, {
    method: 'POST',
    headers: {
      Authorization: token ? `Bearer ${token}` : '',
    },
  });
  
  if (!res.ok) {
    const errorData = await res.json().catch(() => ({}));
    throw new Error(errorData.detail || 'Failed to join event');
  }
  
  return res.json();
}

export async function fetchSpeedDatingEvent(eventId) {
  const token = localStorage.getItem('token');
  const res = await fetch(`${API_BASE}/api/speeddating/events/${eventId}`, {
    headers: {
      Authorization: token ? `Bearer ${token}` : '',
    },
  });
  
  if (!res.ok) {
    throw new Error('Failed to fetch event');
  }
  
  return res.json();
}

export async function likeSpeedDatingPartner(eventId, roundIndex, partnerId) {
  const token = localStorage.getItem('token');
  const res = await fetch(`${API_BASE}/api/speeddating/events/${eventId}/like`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: token ? `Bearer ${token}` : '',
    },
    body: JSON.stringify({
      round_index: roundIndex,
      partner_id: partnerId,
    }),
  });
  
  if (!res.ok) {
    throw new Error('Failed to like partner');
  }
  
  return res.json();
}
